// extracted by mini-css-extract-plugin
module.exports = {"Comment":"Comments__Comment__1GDSX","Text":"Comments__Text__2G2Sg"};